import { Button, Card, Carousel, Col, Row } from 'antd';
import React from 'react';
import Logo from '../../assets/notificationapi-logo-black-vertical.png';
import { SignForm } from '../../models/signForm';
import { useLocation } from 'react-router-dom';
import SignIn from './signIn';
import ResetPassword from './ResetPassword';
import SignUpContainer from './SignUpContainer';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';

const signInAnnouncementItems: {
  type: string;
  title: string;
  description: string;
  imageSrc: string;
  date: string;
  linkUrl: string;
}[] = [
  {
    type: 'Another SDK?!',
    title: `Vanilla JS Core Library (Headless)`,
    description: `Don't need our prebuilt UIs? Use our core library to access our APIs, WebSocket, and other utilities.`,
    imageSrc:
      'https://cdn.prod.website-files.com/62848c86f245f1727f6ea541/6697ec394fba833ea8e90f3f_Announcing%20Core%20Vanilla%20JS.png',
    date: 'July 17th, 2024',
    linkUrl: 'https://docs.notificationapi.com/reference/js-core/'
  },
  {
    type: 'Oooh, Shiny!',
    title: `In-App Batching`,
    description: `Automatically batch in-app notifications together using our new React SDK.`,
    imageSrc:
      'https://cdn.prod.website-files.com/62848c86f245f1727f6ea541/66856f2cd76ee5bf71c7f56b_In-App%20Digest%20smaller.png',
    date: 'July 3rd, 2024',
    linkUrl: 'https://docs.notificationapi.com/features/digest/#in-app-batching'
  },
  {
    type: 'Big Update!',
    title: `New Front-End SDK`,
    description: `More beautiful, more features, more prebuilt UIs. Compatible with other frameworks.`,
    imageSrc:
      'https://cdn.prod.website-files.com/62848c86f245f1727f6ea541/6661b41e44569d5b4a733ac4_Announcing%20React%20SDK%20from%20NotificationAPI.png',
    date: 'July 2nd, 2024',
    linkUrl: 'https://docs.notificationapi.com/reference/react-sdk'
  }
];
const AuthContainer: React.FC<SignForm> = ({
  authState,
  setAuthState,
  setUser
}) => {
  const location = useLocation();

  return (
    <Row>
      <Col xs={{ span: 24 }} md={{ span: 12 }}>
        <Row
          align="middle"
          justify="center"
          style={{
            height: '100vh',
            minHeight: '100vh',
            padding: '2%'
          }}
        >
          <Col>
            <Card>
              <Row
                justify="center"
                style={{ marginTop: '-40px', marginBottom: '-40px' }}
              >
                <img src={Logo} width={'300px'} alt="" />
              </Row>
              {location.pathname === '/signup' && (
                <SignUpContainer
                  authState={authState}
                  setAuthState={setAuthState}
                  setUser={setUser}
                />
              )}
              {location.pathname === '/signin' && (
                <SignIn
                  authState={authState}
                  setAuthState={setAuthState}
                  setUser={setUser}
                />
              )}
              {location.pathname === '/resetpassword' && (
                <ResetPassword
                  authState={authState}
                  setAuthState={setAuthState}
                  setUser={setUser}
                />
              )}
            </Card>
          </Col>
        </Row>
      </Col>
      <Col style={{ background: '#FF2D55' }} xs={{ span: 0 }} md={{ span: 12 }}>
        <Row justify="center" align="middle" style={{ height: '100%' }}>
          <Col>
            <Carousel
              autoplay
              style={{ width: '450px', minHeight: '600px' }}
              autoplaySpeed={5000}
              effect={'fade'}
            >
              {signInAnnouncementItems.map((item) => {
                return (
                  <Card key={item.title}>
                    <Row justify="center">
                      <Title
                        level={2}
                        style={{ marginTop: '-10px', fontWeight: 'bold' }}
                      >
                        {item.type}
                      </Title>
                    </Row>
                    <Row justify="center">
                      <Title
                        level={2}
                        style={{
                          marginTop: '-10px',
                          fontWeight: 'lighter',
                          textAlign: 'center'
                        }}
                      >
                        {item.title}
                      </Title>
                    </Row>
                    <Row justify="center">
                      <img
                        width={400}
                        src={item.imageSrc}
                        alt=""
                        style={{
                          boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.65)',
                          borderRadius: '5px',
                          marginBottom: '10px'
                        }}
                      ></img>
                      <Paragraph style={{ textAlign: 'center' }}>
                        {item.description}
                      </Paragraph>
                      <Text
                        type="secondary"
                        strong
                        style={{
                          fontSize: '10px',
                          marginTop: '-10px',
                          marginBottom: '5px'
                        }}
                      >
                        {item.date.toUpperCase()}
                      </Text>
                    </Row>
                    <Button
                      type="primary"
                      size="large"
                      ghost
                      block
                      onClick={() => window.open(item.linkUrl)}
                    >
                      Read More
                    </Button>
                  </Card>
                );
              })}
            </Carousel>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AuthContainer;
